import { CategoryColor } from '@models/TagCategory.model';
import { track } from '../utils';

export function trackAddTag(
  tagName: string,
  tagCategory: string,
  description: boolean,
) {
  track('Tag Added', {
    'Tag Name': tagName,
    'Tag Category': tagCategory,
    'Included Description': description,
  });
}

export function trackAddCategory(
  tagCategoryName: string,
  description: boolean,
  showOnOnboard: boolean,
  Color: string,
) {
  track('Category Added', {
    'Tag Category': tagCategoryName,
    'Included Description': description,
    'Show On Onboard': showOnOnboard,
    Color,
  });
}

export function trackCombineTags(
  affectedTags: number,
  affectedTagCategories: number,
  tagCategories: string[],
  newTagCategory: string,
) {
  track('Tags Combined', {
    '# of Affected Tags': affectedTags,
    '# of Affected Tag Categories': affectedTagCategories,
    'Tag Categories': tagCategories,
    'New Tag Category': newTagCategory,
  });
}

export function trackMoveTags(
  affectedTags: number,
  affectedTagCategories: number,
  tagCategories: string[],
  newTagCategory: string,
) {
  track('Tags Moved', {
    '# of Affected Tags': affectedTags,
    '# of Affected Tag Categories': affectedTagCategories,
    'Tag Categories': tagCategories,
    'New Tag Category': newTagCategory,
  });
}

export function trackDeletedTags(
  affectedTags: number,
  affectedTagCategories: number,
  tagCategories: string[],
) {
  track('Tags Deleted', {
    '# of Affected Tags': affectedTags,
    '# of Affected Tag Categories': affectedTagCategories,
    'Tag Categories': tagCategories,
  });
}

export function translateCategoryColor(selectedColor: CategoryColor) {
  if (selectedColor === '#E7E4F9') return 'Violet';
  if (selectedColor === '#DCF2EA') return 'Green';
  if (selectedColor === '#FFEFD2') return 'Yellow';
  if (selectedColor === '#D3F5F7') return 'Teal';
  if (selectedColor === '#F8E3DA') return 'Orange';
  if (selectedColor === '#FBDDF3') return 'Pink';
  if (selectedColor === '#F9DADA') return 'Red';
  if (selectedColor === '#E6EDFF') return 'Blue';
  return 'Uncategorized';
}
